import { makeStyles } from '@griffel/react';
import type { GriffelClassNames } from '@ms/yammer-web-core-ui/dist/util/classNames';

export const useClassNames: () => GriffelClassNames<'yammerLogo'> = makeStyles({
  yammerLogo: {
    fill: 'var(--colorBrandForeground1)',
  },
});
